import { SGSInput, SGSInputProps } from 'components';
import { convertSpecialCharacters } from 'core/utils/utils';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = SGSInputProps & {
    uppercase?: boolean;
    minRows?: number;
    alphanumeric?: boolean;
    fullWidth?: boolean;
};

const SGSFormInput: React.FC<Props> = ({ name, label, type, variant, minRows, uppercase, alphanumeric, fullWidth = false, ...props }) => {
    const { control } = useFormContext();
    const { t } = useTranslation();

    const formatValue = (value) => {
        if (alphanumeric) value = convertSpecialCharacters(value);
        if (uppercase) value = value.toUpperCase();
        return value;
    };

    return (
        <Controller
            {...props}
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <SGSInput
                    {...field}
                    id={name}
                    value={field.value}
                    variant={variant}
                    disabled={props.disabled}
                    label={t(label as string)}
                    multiline={props.multiline}
                    minRows={minRows ? minRows : props.multiline && 5}
                    type={type}
                    InputProps={props.InputProps}
                    inputProps={props.inputProps}
                    InputLabelProps={props.InputLabelProps}
                    error={!!error}
                    helperText={error?.message ?? ''}
                    autoComplete={props.autoComplete}
                    fullWidth={fullWidth}
                    onChange={(e) => {
                        const { value } = e.target;
                        field.onChange(formatValue(value));
                    }}
                ></SGSInput>
            )}
        />
    );
};

export default SGSFormInput;
